module.exports = __webpack_public_path__ + "static/cfg-header-848a4ea4cee20b5eafa056c623c5c00b.jpeg";